var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBeachBottomRight = function SvgBeachBottomRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "20.82 -27.202 145.014 95.347"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#BeachBottomRight_svg__a)",
    d: "m23.544-9.141 149.74-7.798-.033 86.383-154.718 5.324z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#90F6DF",
    d: "m-10.83-28.363 162.579-6.838s-36.38 46.468-57.717 37.954C72.694-5.762 70.123 16.561 66.796 39.916s-22.841 7.22-34.624 31.85-47.494-16.237-47.494-16.237z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.931 77.794c-6.483 12.609 1.497 20.053 13.281-4.579s31.299-8.496 34.627-31.853C72.166 18.005 74.738-4.32 96.077 4.196c21.339 8.515 14.766-16.144 43.989-11.749 24.566 3.694 50.441-19.641 40.31-25.893-7.678-4.738-52.625-1.707-55.39.277-34.38 24.673-58.866-3.04-67.045 32.068-2.021 8.675-2.822 15.397-2.588 20.771.347 7.99-3.018 15.249-11.617 16.834-6.631 1.222-10.804 4.01-13.531 9.04-2.576 4.751-3.811 11.15-5.52 20.006-.293 1.523-1.982 8.798-3.754 12.244m5.191-11.797c3.305-17.126 4.963-25.722 18.105-28.144 7.189-1.325 10.144-3.98 11.657-8.728.815 8.404 1.243 11.125-10.069 14.715-16.136 5.121-14.242 9.207-19.922 23.343z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#90F6DF",
    d: "M70.176-5.655c2.205-5.859-1.348-8.852-4.241-3.05-2.894 5.801 2.037 8.909 4.241 3.05"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "BeachBottomRight_svg__a",
    x1: 300.031,
    x2: 335.115,
    y1: -32.627,
    y2: 87.223,
    gradientTransform: "matrix(.61363 0 0 1 -57.95 -10.027)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffE7C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE0B2"
  })))));
};
export default SvgBeachBottomRight;